import _ from 'lodash';
import { Link } from 'react-router-dom';
import moment from 'moment';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

import {
  Column,
  ColumnName,
  ColumnValue,
  Container,
  Divider,
  Grid,
  Row,
  Title,
  Icon,
} from './styles';

class Employment extends Component {
  join = (lists) => lists.map((list) => list.name).join(', ');

  formatStartDate = (startDate) => {
    const month = _.get(startDate, 'month') && _.get(startDate, 'month').toString();
    const year = _.get(startDate, 'year') && _.get(startDate, 'year').toString();

    if (!month || !year) {
      return null;
    }

    return `${moment().month(month - 1).format('MMM')} ${year} - Present`;
  }

  render() {
    const { profile, link } = this.props;
    const { currentPosition: currentPositionProfile, linkedinFields, jobCategories } = profile;
    const currentPosition = !_.isEmpty(currentPositionProfile) ? currentPositionProfile : _.get(linkedinFields, 'currentPosition');

    return (
      <Container>
        <Title>
          Employment
          <Link to={link}><Icon name="pencil" /></Link>
        </Title>
        <Divider />
        {currentPosition && (
          <>
            <Grid columns={1}>
              <Row>
                <Column weight="500" width={16}>
                  <ColumnName>
                    {_.get(currentPosition, 'title')}
                    ,
                    {_.get(currentPosition, 'company.name')}
                  </ColumnName>
                </Column>
              </Row>
              <Row>
                <Column width={16}>
                  <ColumnValue>
                    {this.formatStartDate(_.get(currentPosition, 'startDate'))}
                  </ColumnValue>
                </Column>
              </Row>
              <Row>
                <Column width={16}>
                  <ColumnValue>
                    {_.get(currentPosition, 'description')}
                  </ColumnValue>
                </Column>
              </Row>
            </Grid>
            <Grid columns={2}>
              <Row>
                <Column weight={500} width={3}>
                  <ColumnName>
                    Industry
                  </ColumnName>
                </Column>
                <Column width={12}>
                  <ColumnValue>
                    {_.get(currentPosition, 'company.industry')}
                  </ColumnValue>
                </Column>
              </Row>
              <Row>
                <Column weight={500} width={3}>
                  <ColumnName>
                    Company Size
                  </ColumnName>
                </Column>
                <Column width={12}>
                  <ColumnValue>
                    {_.get(currentPosition, 'company.size')}
                  </ColumnValue>
                </Column>
              </Row>
              <Row>
                <Column weight={500} width={3}>
                  <ColumnName>
                    Seniority
                  </ColumnName>
                </Column>
                <Column width={12}>
                  <ColumnValue>
                    {_.get(currentPosition, 'seniority')}
                  </ColumnValue>
                </Column>
              </Row>
            </Grid>
          </>
        )}

        {!currentPosition && (
          <Grid columns={1}>
            <Row>
              <Column width={16}>
                <ColumnName>
                  Current position is empty
                </ColumnName>
              </Column>
            </Row>
          </Grid>
        )}
        {(!_.isEmpty(jobCategories)) ? (
          <>
            <Title>Job Roles</Title>
            <Divider />
            <Grid columns={1}>
              <Row>
                <Column width={12}>
                  <ColumnValue>
                    {this.join(jobCategories)}
                  </ColumnValue>
                </Column>
              </Row>
            </Grid>
          </>
        ) : null}
      </Container>
    );
  }
}

Employment.propTypes = {
  profile: PropTypes.object.isRequired,
  link: PropTypes.string.isRequired,
};

export default Employment;
